(() => {
  const scrollOptions = { passive: true, capture: true };

  const getScrollTop = (event) => {
    const eventTarget = event?.target;
    const eventTargetScrollTop = eventTarget && eventTarget !== document ? eventTarget.scrollTop : 0;
    const documentScrollTop = document.scrollingElement?.scrollTop || document.documentElement.scrollTop || 0;

    return Math.max(window.pageYOffset || 0, documentScrollTop, eventTargetScrollTop);
  };

  const updateHeaderBackground = (event) => {
    const header = document.querySelector('.section-header');
    const headerWrapper = header?.querySelector('.header-wrapper--transparent-at-top');

    if (!header || !headerWrapper) return;

    const isAtTop = getScrollTop(event) <= 0;
    const background = isAtTop ? 'transparent' : '#fff8ef';

    header.classList.toggle('section-header--transparent-active', isAtTop);
    header.classList.toggle('section-header--transparent-scrolled', !isAtTop);
    headerWrapper.classList.toggle('header-wrapper--transparent-active', isAtTop);
    headerWrapper.classList.toggle('header-wrapper--transparent-scrolled-opaque', !isAtTop);
    headerWrapper.style.setProperty('background', background, 'important');
    headerWrapper.style.setProperty('background-color', background, 'important');
    headerWrapper.style.setProperty('background-image', 'none', 'important');
  };

  window.addEventListener('scroll', updateHeaderBackground, scrollOptions);
  document.addEventListener('scroll', updateHeaderBackground, scrollOptions);
  window.addEventListener('resize', updateHeaderBackground, scrollOptions);

  updateHeaderBackground();
})();
